module.exports = __webpack_public_path__ + "static/media/ndungu.b77c51be.jpg";